import { Route } from 'vue-router';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { Filter } from '@/interfaces/filters/filter';
import router from '@/router';
import store from '@/store/store';
import { tryParseInt } from './number';

/**
 * Przygotowuje podstawowe zapytanie
 *
 * @param {Route} route
 * @returns {object}
 */
export function prepareQuery(route: Route, withDefaultSort?: boolean): Filter {
  return {
    count: tryParseInt(route.query.count) || -1,
    start: tryParseInt(route.query.start),
    search: route.query.search as string,
    ...getSortRoute(route, withDefaultSort)
  };
}

/**
 * Pobiera sortowanie dla kolumn
 *
 * @param {Route} route
 * @param {boolean} [withDefaultSort=false]
 * @returns {{ order: string; desc: boolean }}
 */
function getSortRoute(route: Route, withDefaultSort?: boolean): { order: string; desc: boolean } {
  let sortRoute = {
    order: route.query.order as string,
    desc: route.query.desc === 'true' || (route.query.desc as any) === true
  };

  if (withDefaultSort && !sortRoute.order && store.state?.setting?.settings[PublicSettings.COLUMNS]) {
    const columns = JSON.parse(store.state.setting.settings[PublicSettings.COLUMNS].value);

    for (const column of columns) {
      if (column.defaultSort) {
        sortRoute.order = column.name;
        sortRoute = { ...sortRoute, ...column.defaultSort };
        route.query.order = column.name;

        Object.entries(column.defaultSort).forEach(sortValue => (route.query[sortValue[0]] = sortValue[1] as string));

        router.replace(route);
        break;
      }
    }
  }
  return sortRoute;
}
